/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconHistory8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M5.434 4.269a.667.667 0 0 1-.767 1.09l-1.05-.647a.667.667 0 0 1-.284-.545v-1.5a.667.667 0 0 1 1.334 0V3.82l.767.449Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM6.667 4a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHistory12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M8.15 6.403A1 1 0 1 1 7 8.039l-1.575-.971A1 1 0 0 1 5 6.25V4a1 1 0 0 1 2 0v1.73l1.15.673Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0Zm-2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHistory16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm0-2A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm3.357-3.736a1 1 0 0 0-.342-1.371L9 7.683V5a1 1 0 1 0-2 0v3.25a1 1 0 0 0 .486.857l2.5 1.5a1 1 0 0 0 1.371-.342Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconHistory24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm4.42-5.106a1 1 0 0 0-.526-1.313L13 12.34V7a1 1 0 1 0-2 0v5.67c0 .6.358 1.143.91 1.379l3.196 1.37a1 1 0 0 0 1.313-.525Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconHistory = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconHistory(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconHistory8 {...iconProps} />;
        case '12':
            return <IconHistory12 {...iconProps} />;
        case '16':
            return <IconHistory16 {...iconProps} />;
        case '24':
            return <IconHistory24 {...iconProps} />;
        default:
            return <IconHistory24 {...iconProps} />;
    }
});
